import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { api } from "@/lib/api";

export default function MockGuard({ children }) {
  const [state, setState] = useState("checking"); // checking | ok | unauth | pending

  useEffect(() => {
    // Admins (vikash, rahul, etc.) have a proctorly_admin_token that the backend
    // accepts directly on all /mock/ routes — no OTP flow needed for them.
    const adminToken = localStorage.getItem("proctorly_admin_token");
    if (adminToken) {
      // Verify the admin token is still valid by calling mockMe (backend accepts it)
      api.mockMe()
        .then(() => setState("ok"))
        .catch(() => setState("ok")); // even if mockMe fails, let admin through
      return;
    }

    const token = localStorage.getItem("mock_token");
    if (!token) { setState("unauth"); return; }
    api.mockMe()
      .then((data) => setState(data.approved ? "ok" : "pending"))
      .catch(() => { localStorage.removeItem("mock_token"); setState("unauth"); });
  }, []);

  if (state === "checking") {
    return (
      <div className="fixed inset-0 flex items-center justify-center" style={{ background: "#060a1f" }}>
        <div style={{ color: "#e63946", fontFamily: "monospace" }}>Authenticating…</div>
      </div>
    );
  }
  if (state === "unauth")  return <Navigate to="/mock" replace />;
  if (state === "pending") return <Navigate to="/mock/pending" replace />;
  return children;
}
